import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'; // Add ReactiveFormsModule
import { HeaderComponent } from '../../header/header.component';
import { Router } from '@angular/router';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { CallcenterService } from 'src/app/services/callcenter.service';

@Component({
  selector: 'app-callcenter-login',
  standalone: true,
  imports: [CommonModule, HeaderComponent, ReactiveFormsModule], // Add ReactiveFormsModule here
  templateUrl: './callcenter-login.component.html',
  styleUrl: './callcenter-login.component.scss'
})
export class CallcenterLoginComponent implements OnInit {
  signupForm: FormGroup;
  loginForm: FormGroup;
  setPassword: boolean = false; // Toggle between login and register forms
  errorLabel: string = '';

  constructor(
    private callcenterService: CallcenterService,
    private formBuilder: FormBuilder,
    private route: Router,
    private localStorageService: LocalstorageService
  ) {
    // Login Form
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });

    // Register Form
    this.signupForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    // Check if the user is already logged in
    const currentUser = this.localStorageService.getEmployeeDetails();
    if (currentUser.email) {
      this.loginForm.get('email')?.setValue(currentUser.email);
    }
  }

  // Toggle to Register Form
  enableRegister(event: Event) {
    event.preventDefault();
    this.setPassword = true;
  }

  // Toggle to Login Form
  enableLogin(event: Event) {
    event.preventDefault();
    this.setPassword = false;
  }

  // Toggle Password Visibility
  togglePassword(elementName: string) {
    const passwordInput = document.getElementById(elementName) as HTMLInputElement;
    if (passwordInput) {
      passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
    }
  }

  // Validate Login
  validateLogin() {
    const loginDetails = {
      email: this.loginForm.get('email')?.value,
      password: this.loginForm.get('password')?.value
    };
    this.callcenterService.loginCallcenterWithExisting(loginDetails).subscribe(
      (res: any) => {
        this.localStorageService.setEmailInLocalStorage(loginDetails.email);
        this.route.navigate(['/callcenter/dashboard']);
      },
      (error: any) => {
        console.log(error)
        this.errorLabel = 'Incorrect email or password';
      }
    );
  }

  // Register New Super Admin
  signupUser() {
    const signUpDetails = {
      email: this.signupForm.get('email')?.value,
      password: this.signupForm.get('password')?.value
    };

    this.callcenterService.signUpAsCallcenter(signUpDetails).subscribe(
      (res: any) => {
        this.localStorageService.setEmailInLocalStorage(signUpDetails.email);
        this.route.navigate(['/callcenter/dashboard']);
      },
      (error: any) => {
        this.errorLabel = 'Registration failed. Please try again.';
      }
    );
  }
}